import React from 'react';
import { Link } from 'react-router-dom';
import StoreLayout from './StoreLayout';
import { useCategories } from './catalogApi';
import { CORPORATE } from './storeConfig';
import { categoryLink, useDocumentTitle } from './retailUtils';

// What companies get. Kept to what eYantra does today: bulk orders through a quote, logo
// branding with a mock-up to approve, GST invoices and delivery across India.
const OFFER = [
  { title: 'Your logo on it', text: 'Custom branding on the products you choose, with a mock-up for you to approve before production.' },
  { title: 'Bulk quantities', text: 'From a small team to company-wide orders, at prices for your quantity.' },
  { title: 'GST invoices', text: 'Every order comes with a GST invoice in your company’s name.' },
  { title: 'Delivery across India', text: 'To one office or many, from our offices in Hyderabad, Noida, Mumbai and Bengaluru.' },
];

const STEPS = [
  { title: 'Choose products', text: 'Browse the catalogue and add what you need to your bag, with quantities.' },
  { title: 'Request a quote', text: 'Send your bag. We reply with prices for your quantity and branding.' },
  { title: 'Approve the mock-up', text: 'See your logo on the product before anything is produced.' },
  { title: 'Delivered', text: 'Packed and shipped to your offices, with a GST invoice.' },
];

const POPULAR = 6;

/** /corporate — the store's page for companies. The rest of the store speaks to individual
 *  shoppers; bulk orders and logo branding are explained here. */
export default function StoreCorporatePage() {
  useDocumentTitle('Corporate orders');
  const categories = useCategories();

  return (
    <StoreLayout wide>
      <section className="rt-hero-text sf-hero">
        <div className="rt-eyebrow">Corporate orders</div>
        <h1 className="rt-display">Branded with <span className="sf-accent-word">your logo</span></h1>
        <p className="sf-hero-text">Gifts and merchandise from the brands your teams love, in bulk, branded with your logo and delivered to every office across India.</p>
        <div className="sf-hero-actions">
          <Link to="/catalog" className="rt-btn">Browse products</Link>
          <Link to="/gallery" className="rt-btn rt-btn--ghost">See our work</Link>
        </div>
      </section>

      <div className="rt-pad sf-corp">
        <section aria-labelledby="sf-corp-offer">
          <h2 id="sf-corp-offer" className="sf-corp-title">What you get</h2>
          <div className="sf-corp-grid">
            {OFFER.map(o => (
              <div key={o.title} className="sf-corp-card">
                <h3>{o.title}</h3>
                <p>{o.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section aria-labelledby="sf-corp-steps">
          <h2 id="sf-corp-steps" className="sf-corp-title">How it works</h2>
          <ol className="sf-corp-steps">
            {STEPS.map((s, i) => (
              <li key={s.title}>
                <span className="sf-corp-step-no">{i + 1}</span>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </li>
            ))}
          </ol>
        </section>

        {categories.length > 0 && (
          <section aria-labelledby="sf-corp-popular">
            <h2 id="sf-corp-popular" className="sf-corp-title">Start browsing</h2>
            <div className="sf-corp-chips">
              {categories.slice(0, POPULAR).map(c => (
                <Link key={c.name} to={categoryLink(c.name)} className="rt-btn rt-btn--ghost rt-btn--sm">{c.name}</Link>
              ))}
              <Link to="/catalog" className="rt-btn rt-btn--ghost rt-btn--sm">All products</Link>
            </div>
          </section>
        )}

        <section className="sf-corp-contact">
          <h2 className="sf-corp-title">Talk to us</h2>
          <p>Planning a large order, or need something not in the catalogue? Email <a href={`mailto:${CORPORATE.email}`} className="rt-link">{CORPORATE.email}</a> and our team will help.</p>
        </section>
      </div>
    </StoreLayout>
  );
}
